import RestClient from './rest-client'

export default class Country extends RestClient {
  static get url () {
    return this.apiUrl + '/countries'
  }
  
  static get paramKey () {
    return 'country'
  }

  async getCountries () {
    const { data } = await this.constructor._get(this.constructor.url + '/all_countries')
    return data
  }
}
